import type { FC } from 'react';

import { Illustration, IllustrationProps } from '../IllustrationWrapper';

export const DetachedHouse: FC<IllustrationProps> = ({ size, color }) => (
  <Illustration size={size} color={color}>
    <path d="M68.5 70H11.5C11.1022 70 10.7206 69.842 10.4393 69.5607C10.158 69.2793 10 68.8978 10 68.5V33.5C10.0014 33.2709 10.0542 33.045 10.1546 32.839C10.255 32.6331 10.4004 32.4523 10.58 32.31L39.16 10.31C39.4236 10.1112 39.7448 10.0037 40.075 10.0037C40.4052 10.0037 40.7264 10.1112 40.99 10.31L69.42 32.31C69.6007 32.4513 69.7469 32.6319 69.8474 32.838C69.9479 33.0442 70.0001 33.2706 70 33.5V68.5C70 68.8978 69.842 69.2793 69.5607 69.5607C69.2794 69.842 68.8978 70 68.5 70ZM13 67H67V34.24L40.07 13.4L13 34.24V67Z" />{' '}
  </Illustration>
);
